import * as channelActionTypes from './types';
import * as channelActions from './actions';
import reducer from './reducer';

export {
  channelActionTypes,
  channelActions
};

export default reducer;